<template>
  <video id="videoPlayer" :poster='cover' controls style="width:100%" preload="metadata"></video>
</template>

<script>

export default {
  name: 'QuickVideoPlayer',
  components: {
    
  },
  data(){
    return {
      cover:''
    }
  },
  props: {
    video: null
  },
  methods:{

  },
  mounted(){

    const videoPlayer=document.getElementById("videoPlayer");

    const _this=this;

    videoPlayer.onended=()=>{

      _this.$common.playMedia(videoPlayer, _this.video.filename, '');


    }; 
    
    videoPlayer.onplay=()=>{

      _this.$common.confirmPlay(videoPlayer.src);

    };

    videoPlayer.onerror=()=>{

      if(videoPlayer.src.endsWith('status-1'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'无效的音视频文件', life: 6000});

      if(videoPlayer.src.endsWith('status-2'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'已经超过试用播放次数，请联系二维码所有人或 88 二维码客服', life: 6000});

      if(videoPlayer.src.endsWith('status-3'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'音视频播放流量余额不足，请联系二维码所有人或 88 二维码客服', life: 6000});


    };

    this.$common.playMedia(videoPlayer, this.video.filename, '');

    this.cover=JSON.parse(this.video.misc).cover;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>